import {useNavigate} from "react-router-dom";
import {decorationAPI} from "../../../services/DecorationService";
import {Alert, Button, Container} from "@mui/material";
import {ArrowBackIosNew} from "@mui/icons-material";
import DecorationForm from "./DecorationForm";
import {itemAPI} from "../../../services/ItemServices";
import {SaveDecorationGuidRequest} from '../../../models/Decorations/IDecorationGuid';
import {useAppTranslation} from '@mybake/ui/hooks/useAppTranslation';
import {ApiErrorFeedback} from '../../common/ApiErrorFeedback';
import {ContentSkeleton} from '../../common/loading/ContentSkeleton';

export const DecorationCreatePage = () => {
    const navigate = useNavigate();
    const {t} = useAppTranslation();

    const {
        data: itemsData,
        isError: itemsIsError,
        error: itemsError,
        isLoading: itemsIsLoading,
        isSuccess: itemsIsSuccess,
        refetch: refetchItems,
    } = itemAPI.useGetAllItemsV2LightQuery();
    const [createDecoration] = decorationAPI.useCreateDecorationV2Mutation();
    const handleCreateMode = () => {
        navigate("..", {relative: "path"});
    }

    const handleCreateDecoration = async (formData: SaveDecorationGuidRequest) => {
        await createDecoration(formData).unwrap();
        handleCreateMode();
    }

    return (
        <Container maxWidth="xl" sx={{py: 4,}}>
            <Button variant="outlined" startIcon={<ArrowBackIosNew/>}
                    onClick={() => navigate("..", {relative: "path"})}>
                {t('recipes:back_to_decorations')}
            </Button>
            {itemsIsLoading && <ContentSkeleton variant="form"/>}
            {itemsIsError && <ApiErrorFeedback error={itemsError} retryAction={<Button color="inherit" onClick={() => refetchItems()}>{t('settings:retry')}</Button>}/>}
            {itemsIsSuccess && <DecorationForm key={'isCreateMode'} availableItems={itemsData} changeMode={handleCreateMode} onSubmit={handleCreateDecoration}/>}
        </Container>
    );
}
